module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"To activate a registered professional or contractor account","titleDesc":"Please complete the following (all fields with (*) are mandatory for completion):"},"zh_hk":{"title":"激活註冊的專業人士或承建商帳戶","titleDesc":"請完成以下操作（所有帶有（*）的字段均為必填項）："},"zh_cn":{"title":"激活注册的专业人士或承建商帐户","titleDesc":"请完成以下操作（所有带有（*）的字段均为必填项）："}}')
  delete Component.options._Ctor
}
